import type { BeforeSendFn, CaptureResult } from 'posthog-js';

const NOISE_EXCEPTION_PATTERNS: readonly string[] = [
  'Script error.',
  'Object Not Found Matching Id',
  'ResizeObserver loop completed with undelivered notifications',
  'Transition was aborted because of invalid state',
  'Transition was skipped',
  'Skipping view transition because viewport size changed',
  'Skipping view transition because skipTransition() was called',
  'View transition was skipped because document visibility state is hidden',
  // Stale X/Twitter conversion tag in GTM fires twq() without the base pixel (X conversions moved to server-side CAPI)
  'twq is not defined',
  "Can't find variable: twq",
];

function getExceptionMessage(event: CaptureResult): string | undefined {
  const props = event.properties ?? {};
  const message = props.$exception_message;
  if (typeof message === 'string') return message;
  const list = props.$exception_list;
  if (Array.isArray(list) && list.length > 0 && typeof list[0]?.value === 'string') {
    return list[0].value;
  }
  return undefined;
}

export function isNoiseExceptionEvent(event: CaptureResult | null | undefined): boolean {
  if (!event || event.event !== '$exception') return false;
  const message = getExceptionMessage(event);
  if (!message) return false;
  return NOISE_EXCEPTION_PATTERNS.some((pattern) => message.includes(pattern));
}

export const dropNoiseExceptions: BeforeSendFn = (event) => {
  if (isNoiseExceptionEvent(event)) return null;
  return event;
};
